const notifications = {
    '1': require('./demo_data/notifications-1.json'),
    '2': require('./demo_data/notifications-2.json'),
    '3': require('./demo_data/notifications-3.json')
}

export default {
    getList(data) {
        return new Promise((resolve, reject) =>
            setTimeout(function() {
                resolve(notifications[data.pageIndex])
                reject('Error Occured')
            }, 300)
        )
    },
    updateNotification(data) {
        return new Promise((resolve, reject) =>
            setTimeout(function() {
                // console.log('notificationService updateNotification', data)
            }, 300)
        )
    }
}
